import CoreInstance from '../CoreInstance';
import { getTransformOpts } from '../adapters/transforms';
import { collectionResourcesAdapter } from '../adapters/dapAdapters';
import { localeFlag, setParam, getHeadersWithTokens } from '../ApiHelpers';

interface ICustomCollection {
  getCustomCollections(page?: number, filter?: string): any;
  getCustomCollection(collectionId: number): any;
  getCustomCollectionResources(collectionId: number, page: number, filter?: string): any;
  deleteCustomCollection(collectionId: number): any;
  createCustomCollection(body: any): any;
  editCustomCollection(collectionId: number, body: any): any;
}

const customCollections: ICustomCollection = {
  getCustomCollections: (page?, filter?) => CoreInstance.get(`/centers/custom_collections?${localeFlag()}${page ? `&per_page=10&page=${page}` : ''}${filter ? `&${filter}` : ''}`, getHeadersWithTokens()),
  getCustomCollection: (collectionId) => CoreInstance.get(`/centers/custom_collections/${collectionId}?${localeFlag()}`, getHeadersWithTokens()),
  getCustomCollectionResources: (collectionId, page, filter) =>
    CoreInstance.get(`/centers/custom_collections/${collectionId}/resources?page=${page}&per_page=60&${localeFlag()}${setParam('filter', filter)}`, { ...getHeadersWithTokens(), ...getTransformOpts(collectionResourcesAdapter) }),
  deleteCustomCollection: (collectionId) => CoreInstance.delete(`/centers/custom_collections/${collectionId}`),
  createCustomCollection: (body: any) => CoreInstance.post('/centers/custom_collections', body),
  editCustomCollection: (collectionId, body) => CoreInstance.put(`/centers/custom_collections/${collectionId}`, body),
};

export default customCollections;
